import { SohoApiModel, SohoModel } from "./SohoModel"

export const SitecoreApi = {
  navigation: `${SohoApiModel[SohoModel.Sitecore]}/api/graph/navigation`,
  pageContent: `${SohoApiModel[SohoModel.Sitecore]}/api/graph/pagecontent`
}
